module.exports = __webpack_public_path__ + "img/radio-studio.14f17e2e.jpg";